export const assistantPathSuffix = '/assistant';
export const assistantGuidePathSuffix = '/assistant/guide';

// note: relative paths cause issues with creator hub navigation
export const assistantRootPath = `/docs${assistantPathSuffix}`;
export const assistantAbsolutePath = `https://create.roblox.com${assistantRootPath}`;

export const assistantNavTabKey = 'Assistant';
